var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 h-100"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "xl": "2"
    }
  }, [_c('Profile', {
    attrs: {
      "user": _vm.localUser,
      "myAccount": _vm.myAccount,
      "isAdmin": _vm.isAdmin,
      "loadingMessages": _vm.loadingMessages,
      "edit": _vm.edit
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "xl": "10"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [(!_vm.edit) ? _c('UserAccount', {
    attrs: {
      "user": _vm.localUser,
      "plan": _vm.plan,
      "sub": _vm.sub,
      "forClient": _vm.forClient,
      "isSending": _vm.isSending,
      "isAdmin": _vm.isAdmin,
      "loadingMessages": _vm.loadingMessages,
      "loadingSubscriptions": _vm.loadingSubscriptions
    },
    on: {
      "toggleEdit": _vm.toggleEdit,
      "handleSave": _vm.handleSave
    }
  }) : _c('div', [(_vm.myAccount || _vm.isAdmin) ? _c('UserAccountAdminForm', {
    attrs: {
      "user": _vm.localUser,
      "isAdmin": _vm.isAdmin,
      "forClient": _vm.forClient,
      "myAccount": _vm.myAccount
    },
    on: {
      "handleSave": _vm.handleSave,
      "handleCancel": _vm.handleCancel
    }
  }) : _c('UserAccountForm', {
    attrs: {
      "user": _vm.localUser,
      "isAdmin": _vm.isAdmin,
      "forClient": _vm.forClient
    },
    on: {
      "handleSave": _vm.handleSave,
      "handleCancel": _vm.handleCancel
    }
  })], 1)], 1), _vm._v(" "), (_vm.isAdmin || !_vm.forClient) ? _c('b-row', {
    staticClass: "mx-0"
  }, [(_vm.displaySurvey) ? _c('b-col', {
    staticClass: "pl-0 pr-2 pb-4",
    attrs: {
      "cols": "12",
      "lg": "6",
      "xl": "4"
    }
  }, [(!_vm.editSurvey) ? _c('SurveyList', {
    attrs: {
      "forClient": _vm.forClient,
      "user": _vm.localUser
    },
    on: {
      "toggleSurvey": _vm.toggleSurvey
    }
  }) : _c('SurveyForm', {
    attrs: {
      "user": _vm.localUser
    },
    on: {
      "toggleSurvey": _vm.toggleSurvey
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "pl-0 pr-2 pb-4",
    attrs: {
      "cols": "12",
      "lg": "6",
      "xl": "4"
    }
  }, [(!_vm.editBiometrics) ? _c('BiometricsList', {
    attrs: {
      "forClient": _vm.forClient,
      "user": _vm.localUser
    },
    on: {
      "toggleBiometrics": _vm.toggleBiometrics
    }
  }) : _c('BiometricsForm', {
    attrs: {
      "user": _vm.localUser
    },
    on: {
      "toggleBiometrics": _vm.toggleBiometrics
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1b13610","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/UserAccount/UserAccountContainer.vue
// module id = nxHr
// module chunks = 2